const percentileInTextColors = {
    VeryLow: `text-percentile-very-low`,
    Low: 'text-percentile-low',
    Medium: 'text-percentile-medium',
    High: 'text-percentile-high',
    Top: 'text-percentile-top',
};

export default percentileInTextColors;
